export default __webpack_public_path__ + "cbc84deeede7bdb5fae0602506ae6aa2.bundle.svg";